"use client";

import { Card } from "react-bootstrap";

const RemixiconContent = () => {
  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4 text-center">
          <pre
            className="code-block"
            style={{
              backgroundColor: "#f5f2f0",
              padding: "15px 20px",
              marginBottom: 0,
              borderRadius: "4px",
              overflowX: "auto",
              fontSize: "14px",
              lineHeight: 1.5,
            }}
          >
            <code
              className="language-markup"
              style={{
                backgroundColor: "transparent",
                padding: "0",
                color: "#333",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            >
              &lt;i
              class=&quot;ri-home-7-lined&quot;&gt;&lt;/i&gt;
            </code>
          </pre>
        </Card.Body>
      </Card>

      <div className="row">
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-home-7-line fs-20"></i>
              <span className="d-block mt-4">ri-home-7-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-store-2-line fs-20"></i>
              <span className="d-block mt-4">ri-store-2-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-mail-open-line fs-20"></i>
              <span className="d-block mt-4">ri-mail-open-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-cloud-line fs-20"></i>
              <span className="d-block mt-4">ri-cloud-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-bar-chart-box-line fs-20"></i>
              <span className="d-block mt-4">ri-bar-chart-box-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-calendar-todo-line fs-20"></i>
              <span className="d-block mt-4">ri-calendar-todo-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-global-line fs-20"></i>
              <span className="d-block mt-4">ri-global-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-flag-2-fill fs-20"></i>
              <span className="d-block mt-4">ri-flag-2-fill</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-service-line fs-20"></i>
              <span className="d-block mt-4">ri-service-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-megaphone-line fs-20"></i>
              <span className="d-block mt-4">ri-megaphone-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-message-2-line fs-20"></i>
              <span className="d-block mt-4">ri-message-2-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-chat-quote-line fs-20"></i>
              <span className="d-block mt-4">ri-chat-quote-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-emoji-sticker-line fs-20"></i>
              <span className="d-block mt-4">ri-emoji-sticker-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-ball-pen-line fs-20"></i>
              <span className="d-block mt-4">ri-ball-pen-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-contrast-2-line fs-20"></i>
              <span className="d-block mt-4">ri-contrast-2-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-collage-line fs-20"></i>
              <span className="d-block mt-4">ri-collage-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <div className="p-4 text-center">
              <i className="ri-bug-fill fs-20"></i>
              <span className="d-block mt-4">ri-bug-fill</span>
            </div>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-scan-line fs-20"></i>
              <span className="d-block mt-4">ri-scan-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-wifi-off-fill fs-20"></i>
              <span className="d-block mt-4">ri-wifi-off-fill</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-eth-line fs-20"></i>
              <span className="d-block mt-4">ri-eth-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-cup-line fs-20"></i>
              <span className="d-block mt-4">ri-cup-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-cake-3-line fs-20"></i>
              <span className="d-block mt-4">ri-cake-3-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-angularjs-line fs-20"></i>
              <span className="d-block mt-4">ri-angularjs-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-edge-new-fill fs-20"></i>
              <span className="d-block mt-4">ri-edge-new-fill</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-xbox-line fs-20"></i>
              <span className="d-block mt-4">ri-xbox-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-map-pin-line fs-20"></i>
              <span className="d-block mt-4">ri-map-pin-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-rocket-line fs-20"></i>
              <span className="d-block mt-4">ri-rocket-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-bus-line fs-20"></i>
              <span className="d-block mt-4">ri-bus-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-motorbike-fill fs-20"></i>
              <span className="d-block mt-4">ri-motorbike-fill</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <i className="ri-image-add-line fs-20"></i>
              <span className="d-block mt-4">ri-image-add-line</span>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-12 text-center mb-4">
          <a
            href="https://remixicon.com/"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary py-2 px-4 text-decoration-none rounded-pill"
          >
            <span className="d-inline-block py-1">View All Icons</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default RemixiconContent;
